import { render, staticRenderFns } from "./DetailsAmountCurrency.vue?vue&type=template&id=c1b90db0&scoped=true"
import script from "./DetailsAmountCurrency.vue?vue&type=script&lang=js"
export * from "./DetailsAmountCurrency.vue?vue&type=script&lang=js"
import style0 from "./DetailsAmountCurrency.vue?vue&type=style&index=0&id=c1b90db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b90db0",
  null
  
)

export default component.exports